export const VIBECODING_PROCESSING_NAMESPACE = '/vibecoding-processing';
export const VIBECODING_PROCESSING_SOCKET_PATH = '/api/socket.io';
export const VIBECODING_PROCESSING_FINISHED_EVENT = 'processing-finished';

export type ProcessingFinishedEvent = {
  instanceId: string;
  versionId: string;
};